import { useGetGtcQuery } from "api/api-marketplace";
import { Grid, Stack } from "@mui/material";
import { useAppSelector } from "redux/hooks";

const GeneralTermsCondition = () => {
  const USER_ROLE = useAppSelector((state) => state.appState.role);
  const { data: gtc } = useGetGtcQuery(USER_ROLE?.id ?? "", {
    skip: !Boolean(USER_ROLE?.id),
  });
  return (
    <Grid
      item
      sx={{
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2ch",
        padding: "2ch",
        height: "inherit !important",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <Stack
        dangerouslySetInnerHTML={{ __html: gtc ?? "" }}
        margin="auto"
        sx={{
          fontSize: "1.1rem",
          "& b": {
            fontSize: "1.2rem",
            fontWeight: "900 !important",
            fontStyle: "italic",
          },
          "& strong": {
            fontWeight: "bold",
            fontSize: "1.5rem",
          },
        }}
      />
    </Grid>
  );
};

export default GeneralTermsCondition;
